'use client';

import { CourseCollection } from 'types/sanity.types';

import { useTranslation } from 'hooks/use-translation';

import DateTerm from 'components/date-term';
import Image from 'components/nextjs-fixes/image';
import Link from 'components/nextjs-fixes/link';

import { styles } from '.';

type TProps = {
  item: CourseCollection;
  //
  locale: string;
};

const CourseListItem = (props: TProps) => {
  const { item, locale } = props;

  const { t } = useTranslation(locale);

  return (
    <Link href={`/${locale}/academy/${item.slug}`} className={styles.container}>
      <figure className={styles.figure}>
        <Image
          className="object-cover"
          fill
          src={item.cover.asset?.url}
          alt="course-cover"
        />
      </figure>
      <div className={styles.content}>
        <div className={styles.head}>
          <DateTerm playDates={item.playDates} t={t} isWithShadow={false} />
          <h3 className={styles.heading}>{item.title}</h3>
          <p className={styles.paragraph}>{item.summary}</p>
        </div>
        <div className={styles.body}>
          <p className={styles.button}>Lees meer</p>
        </div>
      </div>
    </Link>
  );
};

export default CourseListItem;
